<form [formGroup]="parentForm" fxLayout="column">
	<mat-form-field fxFlex>
		<mat-label>{{label}}</mat-label>
		<input (matChipInputTokenEnd)="add($event)" [matChipInputAddOnBlur]="true" [matChipInputFor]="emailList"
			   [placeholder]="placeholder" appMatChipPaste [disabled]="disabled"
			   formControlName="email" fxLayoutAlign="stretch" matInput>
		<mat-icon *ngIf="parentForm?.get('email')?.value?.length > 0" matSuffix>add</mat-icon>
		<mat-error *ngIf="parentForm.get('email')?.errors?.invalidEmail && !isTextMessagingEnabled">Invalid email
			address
		</mat-error>
		<mat-error *ngIf="parentForm.get('email')?.errors?.invalidEmail && isTextMessagingEnabled">Invalid email address
			or
			phone number
		</mat-error>
		<mat-error *ngIf="parentForm.get('email')?.errors?.minLength">Please enter at least one email address
		</mat-error>
		<mat-chip-list #emailList></mat-chip-list>
	</mat-form-field>
	<mat-form-field *ngIf="parentForm?.get('emails')?.value?.length > 0" appearance="none" class="top-15">
		<input matInput class="display-none">
		<mat-chip-list>
			<mat-chip (removed)="remove(i)" *ngFor="let email of parentForm?.get('emails')?.value; let i = index;"
					  [removable]="true">
				{{email}}
				<mat-icon matChipRemove>cancel</mat-icon>
			</mat-chip>
		</mat-chip-list>
	</mat-form-field>
</form>
